export default __webpack_public_path__ + "static/industrial-68fa31b2bc165a1f12482f54b187ef83.png";